import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  DownloadResponse,
  GuidanceServiceInterface,
  InputFormat,
  JobResponse,
  TargetFormat,
  UploadResponse,
} from './guidance.service.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GuidanceService implements GuidanceServiceInterface {
  private http = inject(HttpClient);

  getInputFormat() {
    return this.http.get<InputFormat[]>(`${environment.portal.guidance}/convert/input-formats`);
  }
  getTargetFormat() {
    return this.http.get<TargetFormat[]>(`${environment.portal.guidance}/convert/target-formats`);
  }
  createJob(targetFormat: string) {
    return this.http.post<JobResponse>(`${environment.portal.guidance}/jobs`, {
      target_format: targetFormat,
    });
  }
  uploadFile(file: File, url: string) {
    if (file.name.split('.').pop()?.toLowerCase() !== 'zip') {
      throw new Error($localize`Unsupported file type`);
    }
    const headers = new HttpHeaders({ 'Content-Type': `application/zip` });

    return this.http.put<UploadResponse>(url, file, { headers });
  }
  downloadFile(url: string) {
    return this.http.get<DownloadResponse>(url, { responseType: 'blob' as 'json' });
  }
}
